/* assets/expo-read-more.js
 *
 * Clamps a block of text to a number of LINES and puts the toggle inline right
 * after the ellipsis, the way the design shows it. CSS line-clamp cannot do
 * that: it hides the overflow but gives you nowhere to put the link, so the
 * text is trimmed here instead, by binary searching the word count until the
 * block fits the allowed height with the toggle already in place.
 *
 * Collapsed state renders as plain text in a single <p>. Expanded restores the
 * original rich text markup untouched. Re-runs on resize, since the number of
 * words that fit changes with the width.
 *
 * No flash of the full text: the CSS clamps the block to the same number of
 * lines before this runs, and the script removes that clamp (via .is-ready) at
 * the moment it swaps in the trimmed text, so the height never jumps.
 *
 * ES5. No dependencies.
 */
(function () {
  'use strict';

  function lineHeightOf(el) {
    var styles = getComputedStyle(el);
    var value = parseFloat(styles.lineHeight);
    if (!value || isNaN(value)) { value = parseFloat(styles.fontSize) * 1.4; }
    return value;
  }

  function setup(root) {
    if (root.expReadMore) { return; }
    root.expReadMore = true;

    var body = root.querySelector('[data-exp-rm-body]');
    if (!body) { return; }

    var fullHtml = body.innerHTML;
    var fullText = (body.textContent || '')
      .replace(/ /g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!fullText) { return; }

    var moreLabel = root.getAttribute('data-more') || 'Read More';
    var lessLabel = root.getAttribute('data-less') || 'Read Less';
    var expanded = false;

    function allowedLines() {
      var raw = window.innerWidth >= 750
        ? root.getAttribute('data-lines-desktop')
        : root.getAttribute('data-lines-mobile');
      var value = parseInt(raw, 10);
      return value > 0 ? value : 2;
    }

    function makeToggle(label) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'exp-rm__toggle';
      button.textContent = label;
      button.addEventListener('click', function () {
        expanded = !expanded;
        render();
      });
      return button;
    }

    function render() {
      /* Drop the CSS clamp that held the collapsed height during first paint.
         From here the height is controlled by how much text is left in. */
      root.classList.add('is-ready');

      if (expanded) {
        body.innerHTML = fullHtml;
        var last = body.lastElementChild;
        if (!last) {
          last = document.createElement('p');
          body.appendChild(last);
        }
        last.appendChild(document.createTextNode(' '));
        last.appendChild(makeToggle(lessLabel));
        return;
      }

      body.innerHTML = '';
      var paragraph = document.createElement('p');
      body.appendChild(paragraph);

      var textNode = document.createTextNode(fullText);
      paragraph.appendChild(textNode);

      var maxHeight = lineHeightOf(paragraph) * allowedLines() + 1;

      /* already short enough: no toggle at all */
      if (body.scrollHeight <= maxHeight) { return; }

      paragraph.appendChild(makeToggle(moreLabel));

      /* longest word count that still fits WITH the toggle rendered */
      var words = fullText.split(' ');
      var low = 0;
      var high = words.length;
      var best = 0;

      while (low <= high) {
        var mid = (low + high) >> 1;
        textNode.nodeValue = words.slice(0, mid).join(' ') + ' …';
        if (body.scrollHeight <= maxHeight) { best = mid; low = mid + 1; }
        else { high = mid - 1; }
      }

      textNode.nodeValue = words.slice(0, best).join(' ') + ' …';
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(render, 150);
    });

    render();
  }

  function init() {
    var roots = document.querySelectorAll('[data-exp-readmore]');
    for (var i = 0; i < roots.length; i++) { setup(roots[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();